import { render } from "./CreateFolderModal.vue?vue&type=template&id=ee864702&scoped=true&ts=true&lang=pug"
import script from "./CreateFolderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateFolderModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateFolderModal.vue?vue&type=style&index=0&id=ee864702&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee864702"]])

export default __exports__